import type { CSSProperties } from 'react';
import { useT } from '../i18n/index.ts';

/**
 * Loading placeholders — Field Notes rebuild (epic #950 PR-8, formerly
 * the console-shared `createSkeletonComponents` factory instantiation).
 */
interface SkeletonProps {
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly testId?: string;
}

interface TableSkeletonProps {
  readonly rows?: number;
  readonly rowHeight?: number;
  readonly testId?: string;
}

export function Skeleton({ className = '', style, testId }: SkeletonProps): JSX.Element {
  return (
    <div
      aria-hidden="true"
      data-testid={testId}
      style={style}
      className={`animate-pulse rounded-lg bg-active/70 ${className}`.trim()}
    />
  );
}

export function TableSkeleton({ rows = 4, rowHeight = 48, testId }: TableSkeletonProps): JSX.Element {
  const t = useT();
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} style={{ height: rowHeight }} />
      ))}
      <span className="sr-only">{t('skeleton.loading')}</span>
    </div>
  );
}
